import React from 'react';
import ReactLoading from 'react-loading';


export const InfiniteProgress = ({size=64}) => (
    <ReactLoading className="loading-animation"
                  type="cylon" color="#f633a1"
                  width={size} height={size} />
);
